export const removeCarriageReturnsInText = (text: string | null | undefined) => {
  if(!text){
    return text;
  }
  return text.replaceAll('\r', '');
};
